// dialog.service.ts
import { Injectable, ApplicationRef, ComponentRef, createComponent, EnvironmentInjector } from '@angular/core';
import { Dialog, DialogConfig } from '../components/dialog/dialog';

@Injectable({ providedIn: 'root' })
export class DialogService {
  constructor(private appRef: ApplicationRef, private injector: EnvironmentInjector) { }

  open(config: DialogConfig): Promise<boolean> {
    return new Promise<boolean>((resolve) => {
      const componentRef: ComponentRef<Dialog> = createComponent(Dialog, {
        environmentInjector: this.injector
      });

      componentRef.instance.config = config;
      componentRef.instance.closed.subscribe((result: boolean) => {
        this.appRef.detachView(componentRef.hostView);
        componentRef.destroy();
        resolve(result);
      });

      this.appRef.attachView(componentRef.hostView);
      document.body.appendChild((componentRef.hostView as any).rootNodes[0]);
    });
  }
}
